<div class="min-h-screen flex items-center justify-center login-container">
  <!-- Login Container -->
  @if (showForm()) {
  <div class="w-full max-w-md h-screen">
    <!-- Header Section -->
    <div class="text-center mt-28 mb-6">
      <!-- TMA Logo -->
      <div class="flex justify-center mb-4">
        <img
          src="assets/images/logo-menu.jpg"
          alt="TMA Solutions"
          class="h-20 w-auto"
        />
      </div>

      <!-- Title -->
      <h1 class="text-2xl font-semibold text-gray-800">
        {{ "login.welcome.title" | translate }}
      </h1>
    </div>

    <!-- Login Card -->
    <p-card styleClass="border-0 shadow-lg bg-white rounded-xl">
      <ng-template pTemplate="content">
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="space-y-4">
          <!-- Username Field -->
          <div class="space-y-2">
            <label
              for="username"
              class="block text-sm font-medium text-gray-700"
              >{{ "login.form.username.label" | translate }}</label
            >
            <div class="relative">
              <div
                class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none z-10"
              >
                <svg
                  class="h-4 w-4 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                  ></path>
                </svg>
              </div>
              <input
                pInputText
                id="username"
                formControlName="username"
                placeholder="{{
                  'login.form.username.placeholder' | translate
                }}"
                styleClass="mb-4"
                [class.ng-invalid]="hasFieldError('username')"
                [class.ng-dirty]="hasFieldError('username')"
              />
            </div>
            @if (hasFieldError('username')) {
            <p class="text-sm text-red-600">{{ getFieldError("username") }}</p>
            }
          </div>

          <!-- Password Field -->
          <div class="space-y-2">
            <label
              for="password"
              class="block text-sm font-medium text-gray-700"
              >{{ "login.form.password.label" | translate }}</label
            >
            <div class="relative">
              <div
                class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none z-10"
              >
                <svg
                  class="h-4 w-4 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                  ></path>
                </svg>
              </div>
              <p-password
                id="password"
                formControlName="password"
                placeholder="{{
                  'login.form.password.placeholder' | translate
                }}"
                [toggleMask]="true"
                styleClass="mb-4"
                [fluid]="true"
                [feedback]="false"
                [class.ng-invalid]="hasFieldError('password')"
                [class.ng-dirty]="hasFieldError('password')"
              ></p-password>
            </div>
            @if (hasFieldError('password')) {
            <p class="text-sm text-red-600">{{ getFieldError("password") }}</p>
            }
          </div>

          <!-- Login Button -->
          <div class="mt-6">
            <p-button
              type="submit"
              [label]="'login.form.submit' | translate"
              [loading]="isLoading()"
              [disabled]="loginForm.invalid || isLoading()"
              severity="info"
            />
          </div>

          <!-- Error Message -->
          @if (errorMessage()) {
          <div class="mt-4">
            <p-message
              severity="error"
              [text]="errorMessage()"
              styleClass="w-full"
              [closable]="false"
            />
          </div>
          }
        </form>
      </ng-template>
    </p-card>
  </div>
  } @else {
  <!-- Loading state while checking authentication -->
  <div class="w-full max-w-md h-screen flex items-center justify-center">
    <div class="text-center">
      <div
        class="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mb-4"
      ></div>
      <p class="text-gray-600">{{ "login.redirecting.message" | translate }}</p>
    </div>
  </div>
  }
</div>
